import { render, staticRenderFns } from "./BtnExcluirFeriado.vue?vue&type=template&id=6560b4e8"
import script from "./BtnExcluirFeriado.vue?vue&type=script&lang=js"
export * from "./BtnExcluirFeriado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports